import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';
import { zodResolver } from '@hookform/resolvers/zod';
import { Form } from '../../shared/components/Form';
import { EmailTemplateSchema } from '../../shared/types';
import { route } from '../../shared/utils';
import TemplateDetailForm from './components/TemplateDetailForm';
import EmailTemplateDetailHeader from './components/TemplateDetailHeader';
import useCreateEmailTemplate from './hooks/useCreateEmailTemplate';
const EmailTemplateDetailPage = () => {
    const isNew = useParams().id === 'new';
    const navigate = useNavigate();
    const { mutate: createEmailTemplate, isPending: isCreatingEmailTemplate } = useCreateEmailTemplate();
    const method = useForm({
        resolver: zodResolver(EmailTemplateSchema),
        defaultValues: {
            name: '',
            content: '',
            subject: '',
            notification_types: [],
            is_tcpa: true,
        },
    });
    const { formState: { isDirty }, trigger, reset, handleSubmit, } = method;
    const onSubmit = (data) => {
        if (isNew) {
            createEmailTemplate(data, {
                onSuccess: () => {
                    navigate(route('/templates/emails'));
                },
            });
        }
    };
    const triggerSubmit = async () => {
        const isValid = await trigger();
        if (isValid) {
            await handleSubmit(onSubmit)();
        }
    };
    return (_jsx(Form, { ...method, children: _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "form", children: [_jsx(EmailTemplateDetailHeader, { title: isNew ? 'New template title' : '', isDirty: isDirty, isLoading: isCreatingEmailTemplate, onSubmit: triggerSubmit }), _jsx(TemplateDetailForm, { isNew: isNew })] }) }));
};
export default EmailTemplateDetailPage;
